import {
  Card,
  CardHeader,
  Carousel,
  Switch,
  Typography,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { routerPaths } from "../../services/path";
import { BoatService } from "../../services/boatService";
import { formatDistanceToNow } from "date-fns";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { useState } from "react";
import { handleErrorMessage } from "../../utility";
import AvailabilityPopover from "./AvailabilityPopOver";
import { Boat } from "../../models/boat/boat";
import NoImage from "../../assets/images/no_image.svg";
import { AiFillEdit } from "react-icons/ai";
import EditBoatModal from "./EditBoatModal";


type Props = {
  id: number;
  name: string;
  price: string;
  per: string;
  isImageAdded: boolean;
  isPriceAdded: boolean;
  isActive: boolean;
  createdDate: Date;
  boat: Boat;
};

function BoatCard(props: Props) {
  const navigate = useNavigate();
  const { setStepNumber, setTotalSteps, setOnBoardingPage, setTab } =
    useOnboardingStore();

  const handleClick = () => {
    if (props.isImageAdded && props.isPriceAdded) {
      //view boat details
    }

    if (!props.isImageAdded) {
      BoatService.saveCurrentBoatId(props.id.toString());
      setStepNumber(2);
      setTotalSteps(4);
      setTab("Photos");
      setOnBoardingPage("Photos");
      navigate(routerPaths.createBoat);
      return;
    }

    if (!props.isPriceAdded) {
      BoatService.saveCurrentBoatId(props.id.toString());
      setStepNumber(3);
      setTotalSteps(4);
      setTab("Pricing");
      setOnBoardingPage("Pricing");
      navigate(routerPaths.createBoat);
      return;
    }
  };
  const formattedDate = formatDistanceToNow(props.createdDate, {
    addSuffix: true,
  });

  const [switchActive, setSwitchActive] = useState(false);
  const [switchedCheck, setSwitchCheck] = useState(props.isActive);
  const [availabilityPopOver, setAvailabilityPopOver] = useState(false);
  const [editBoatOpen, setEditBoatOpen] = useState(false);

  async function setAvailability(boatId: string) {
    setSwitchActive(true);
    try {
      const request = await api.post(
        `${ApiRoutes.setBoatAvailability}?boatId=${boatId}`
      );
      console.log(request.data);
      if (request.data.payload.statusCode === 200) {
        setSwitchCheck((prev) => !prev);
      }
    } catch (error) {
      handleErrorMessage(error, "Unable to set availability");
    } finally {
      setSwitchActive(false);
    }
  }

  function showDialog() {
    if (!switchedCheck) {
      setAvailability(props.id.toString());
      return;
    }

    setAvailabilityPopOver((prev) => !prev);
  }

  return (
    <Card
      placeholder={undefined}
      onClick={() => handleClick()}
      className="bg-white mb-5"
    >
      <AvailabilityPopover
        open={availabilityPopOver}
        handleOpen={() => setAvailabilityPopOver((prev) => !prev)}
        permanent={() => setAvailability(props.id.toString())}
      />
      {/* <MultipleDayPicker
        open={datePickerOpen}
        handleOpen={() => setDatePickerOpen((pre) => !pre)}
        value={selectedDates[0]}
        setValue={(date) => {
          setSelectedDates(date);
        }}
      /> */}
      <CardHeader
        placeholder={undefined}
        floated={false}
        className="m-0 p-0 rounded-none rounded-t-lg"
      >
        {props.boat.isPriceSet ? (
          <div className="relative ">
            <div
              className="absolute top-5 right-5 z-10  bg-gray-800 p-2 rounded-md"
              onClick={() => {
                setEditBoatOpen(true);
              }}
            >
              <AiFillEdit color="White" size="15" />
            </div>
            <EditBoatModal
              boat={props.boat}
              handleOpen={() => setEditBoatOpen((prev) => !prev)}
              openDialog={editBoatOpen}
            />
            <Carousel
              className="rounded-xl relative"
              placeholder={undefined}
              autoplay
              loop
            >
              <img
                className="object-cover h-[300px] w-full"
                src={props.boat.seaViewImageUrl}
                alt="boat-picture"
              />
              <img
                className="object-cover h-[300px] w-full"
                src={props.boat.frontImageUrl}
                alt="boat-picture"
              />
              <img
                className="object-cover h-[300px] w-full"
                src={props.boat.sideImageUrl}
                alt="boat-picture"
              />
              <img
                className="object-cover h-[300px] w-full"
                src={props.boat.interiorImageUrl}
                alt="boat-picture"
              />
              <img
                className="object-cover h-[300px] w-full"
                src={props.boat.backImageUrl}
                alt="boat-picture"
              />
            </Carousel>
          </div>
        ) : (
          <div className="flex flex-col justify-center h-[300px] w-full bg-gray-100 ">
            <img className="mx-auto" src={NoImage} alt="boat-picture" />
            <div className="text-center pt-3">
              <Typography placeholder={undefined} className="text-gray-500">
                Add boat images
              </Typography>
            </div>
          </div>
        )}
      </CardHeader>

      <CardHeader
        placeholder={undefined}
        floated={false}
        className="m-0 shadow-none p-4 -mt-2"
      >
        <div className="flex items-end">
          <div className="w-full">
            <Typography placeholder={undefined} className="font-semibold">
              {props.name}
            </Typography>
            <Typography placeholder={undefined}>{formattedDate}</Typography>
            {props.isImageAdded ? (
              <Typography placeholder={undefined} className="font-semibold">
                {props.price} /<span className="font-normal"> hour</span>
              </Typography>
            ) : (
              <Typography placeholder={undefined}>Price not added</Typography>
            )}

            {props.boat.tripAvailabilityOptionsName !== undefined && (
              <p>{props.boat.tripAvailabilityOptionsName}</p>
            )}
          </div>
          <div>
            <Switch
              crossOrigin={undefined}
              onClick={() => showDialog()}
              disabled={switchActive}
              defaultChecked={switchedCheck}
              checked={switchedCheck}
              className={"bg-red-500 checked:bg-[#2ec946]"}
              circleProps={{
                className: `${
                  switchedCheck ? "bg-green-500" : "bg-red-500"
                } border-none`,
              }}
            />
          </div>
        </div>
      </CardHeader>
    </Card>
  );
}

export default BoatCard;
